import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const createOrg = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/org/createOrg`, values, token, dispatch);
};

export const updateOrg = ({values, dispatch, token, orgId}) => {
    return ApiClient.put(`${API_URL}/org/updateOrg?orgId=${orgId}`, values, token, dispatch);
};

export const updateOrgLogo = ({values, dispatch, token, orgId}) => {
    return ApiClient.put(`${API_URL}/org/update-org-logo?orgId=${orgId}`, values, token, dispatch);
};

export const updateClinicLogo = ({values, dispatch, token, clinicId}) => {
    return ApiClient.put(`${API_URL}/org/update-clinic-logo?clinicId=${clinicId}`, values, token, dispatch);
};



export const createClinic = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/org/creatClinic?orgId=${values?.orgId}`, values, token, dispatch);
};

export const updateClinic = ({values, dispatch, token, clinicId,currentClinicId ,organizationId}) => {
    return ApiClient.put(`${API_URL}/org/updateClinic?clinicId=${clinicId}&currentClinicId=${currentClinicId}&organizationId=${organizationId}`, values, token, dispatch);
};

export const updateClinicforEHR = ({values, dispatch, token, clinicId,currentClinicId ,organizationId}) => {
    return ApiClient.put(`${API_URL}/org/updateClinic-for-patient-ehr?clinicId=${clinicId}&currentClinicId=${currentClinicId}&organizationId=${organizationId}`, values, token, dispatch);
};

export const clearClinicEHRConnection = ({values, dispatch, token, clinicId,currentClinicId ,organizationId}) => {
    return ApiClient.put(`${API_URL}/org/updateClinic-for-clear-ehr?clinicId=${clinicId}&currentClinicId=${currentClinicId}&organizationId=${organizationId}`, values, token, dispatch);
};


export const activeDeactiveClinic = ({dispatch, token, clinicId, isActive}) => {
    return ApiClient.put(`${API_URL}/org/active-deactive-clinic?clinicId=${clinicId}&isActive=${isActive}`, {}, token, dispatch);
};

export const activeDeactiveOrg = ({dispatch, token, orgId, isActive}) => {
    return ApiClient.put(`${API_URL}/org/active-deactive-org?orgId=${orgId}&isActive=${isActive}`, {}, token, dispatch);
};


export const getOrg = ({dispatch, token, page, limit, searchKey, dataLimit}) => {
    return ApiClient.get(`${API_URL}/org/getOrgs?page=${page}&limit=${limit}&dataLimit=all`, null, token, dispatch);
};

export const getOrgById = ({dispatch, token, orgId}) => {
    return ApiClient.get(`${API_URL}/org/getOrgById?orgId=${orgId}`, null, token, dispatch);
};

export const getClinicsByOrgId = ({dispatch, token, page, limit, searchKey, orgId}) => {
    return ApiClient.get(`${API_URL}/org/getClinicByOrg?orgId=${orgId}&page=${page}&limit=${limit}&searchKey=${searchKey}`, null, token, dispatch);
};

export const getClinicsByOrgIdOrgDetail = ({dispatch, token, page, limit, searchKey, orgId}) => {
    return ApiClient.get(`${API_URL}/org/getClinicByOrgId?orgId=${orgId}&page=${page}&limit=${limit}&searchKey=${searchKey}`, null, token, dispatch);
};

export const getClinicById = ({dispatch, token, clinicId}) => {
    return ApiClient.get(`${API_URL}/org/getClinicById?clinicId=${clinicId}`, null, token, dispatch);
};

export const getAllCountList = ({values, dispatch, token}) => {
    return ApiClient.get(`${API_URL}/org/get-all-count?orgId=${values?.orgId}&clinicId=${values?.clinicId}&userId=${values?.userId}`, values, token, dispatch);
};

export const getAllOrg = ({dispatch, token}) => {
    return ApiClient.get(`${API_URL}/org/getAllOrgs`, null, token, dispatch);
};
